import { Injectable } from '@angular/core';
import { DataModuleWithRelations } from '@osos/shared/api';
import { DataModulePresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases/factory/factory-base';
import { DataModuleParserV1Service } from '../../parsers/data-module-parser/data-module-parser-v1.service';
import { ParserFactory } from '../../services';

@Injectable()
export class DataModuleFactoryService extends FactoryBase<
  DataModuleWithRelations,
  DataModulePresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: DataModuleParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }
  createDataModel(
    presenter: DataModulePresenterModel,
  ): DataModuleWithRelations {
    const parser = this.getParser(
      DataModuleWithRelations,
      DataModulePresenterModel,
      presenter.specificationVersion,
    );
    const result = parser.getDataModel(presenter);

    return result;
  }

  createPresenterModel(
    model: DataModuleWithRelations,
  ): DataModulePresenterModel {
    const parser = this.getParser(
      DataModuleWithRelations,
      DataModulePresenterModel,
      model.specificationVersion,
    );
    const result = parser.getPresenterModel(model);
    return result;
  }
}
